import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef, useState, useCallback, useImperativeHandle } from 'react';
import { utils, ModalPane, Card, Flex, Button, Text, fonts } from '@costar/theme-ui';

var ConfirmationDialog = /*#__PURE__*/forwardRef(function ConfirmationDialog(props, ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var open = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var close = useCallback(function () {
    return setIsOpen(false);
  }, []);
  var onConfirm = useCallback(function () {
    props.onConfirm();
    setIsOpen(false);
  }, [props]);
  useImperativeHandle(ref, function () {
    return {
      open: open,
      close: close,
      isOpen: isOpen
    };
  });
  var id = utils.useUniqueId();
  return /*#__PURE__*/React.createElement(ModalPane, {
    "aria-describedby": id,
    "aria-labelledby": id,
    variant: "modal.cosmos",
    maxWidth: "578px",
    maxHeight: "100%",
    open: isOpen,
    onClose: close,
    useModalAsBackdrop: true,
    zIndex: props.zIndex,
    fontSize: props.fontSize
  }, /*#__PURE__*/React.createElement(Card.Card, {
    useContext: true,
    variant: "card-modal",
    id: "delete-dialog"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Card.Title, {
    color: "black",
    ellipsis: true,
    id: id
  }, props.resources.title()), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "neutral.dark",
    iconSize: "xl",
    iconTop: "close",
    onClick: close,
    p: "0",
    variant: "icon"
  }))), /*#__PURE__*/React.createElement(Card.Content, {
    p: "xl",
    pt: "0"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "body",
    color: "text"
  }, props.resources.message()), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end",
    mt: "md",
    gap: "lg"
  }, props.resources.cancel ? /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    id: "cancel-delete-layout",
    fontFamily: fonts.fonts.body,
    onClick: close,
    height: "button.height"
  }, props.resources.cancel()) : null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    id: "dialog-delete-layout",
    onClick: onConfirm,
    height: "button.height"
  }, props.resources.confirm())))));
});

export { ConfirmationDialog };
//# sourceMappingURL=confirmation-dialog.esm.js.map
